import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app-service.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class ClientLoginComponent {
  id = '';
  constructor(private router: Router, private toastrService: ToastrService,
    private appService: AppService, private route: ActivatedRoute
  ) {
    this.route.params.subscribe((res: any) => {
      if (res.guid) {
        this.id = res.guid;
        this.appService.updateUserStatus(this.id, { status: 'Active' }).subscribe((res: any) => {
          if (res) {
            this.toastrService.success("Account activated successfully", "Account Activation");
            this.router.navigate(['login']);
          }
        });
      }
    })
  }

  public otp: any = false;
  policy_number: string = '';
  email_Id: string = '';
  hasError: boolean = false;
  hasSError: boolean = false;
  ErrorMessage: string = '';
  resendLinkEmailID: string = '';
  loginForm: any;
  otpForm: any;

  isShowOtpPage: any;
  isShowSignup: any;
  hidePassword = true;
  ngOnInit() {
    this.loginForm = new FormGroup({
      username: new FormControl(localStorage.getItem("username") || null, [Validators.required]),
      password: new FormControl(localStorage.getItem("password") || '', [Validators.required]),
    });
  }
  ngAfterViewInit() { }

  SFLogin() {
    if (this.loginForm.valid) {
      let data = this.loginForm.value;
      this.appService.hashPassword(this.loginForm.value.password).then((res: any) => {
        data.password = res;
        this.appService.login(data).subscribe((res: any) => {
          if (res.status !== 'Active') {
            this.toastrService.error('Account is not active', 'Please contact support');
            return;
          } else {
            sessionStorage.setItem("access_token", res.access_token);
            sessionStorage.setItem("email", this.loginForm.value.username);
            sessionStorage.setItem("loginId", res.user_id || '56cfbd08-4fc9-4fc0-ba9b-05b0e292618b');
            const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/user-dashboard';
            this.router.navigate([returnUrl]).then(() => {
              this.appService.getUserStatus(sessionStorage.getItem('loginId')).subscribe((res: any) => {
                // console.log(res); 
                const startDate = new Date(res.completed.endDate);
                // console.log(startDate)
                const currentDate = new Date();
                // console.log(currentDate)
                const diffTime = Math.abs(currentDate.getTime() - startDate.getTime());
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                if (diffDays >= 10) {
                  this.toastrService.info(
                    `It's been ${diffDays} days since you started ${res.inprogress_or_notstarted.chapterName}. Consider completing it soon!`
                  );
                }
              });
            });
          }
        }, (err) => {
          this.toastrService.error('Invalid Details', 'User Details are invalid');
        });
      });
    } else {
      this.toastrService.warning('Invalid Details', 'Please Provide User Details');
    }
  }

  rememberMe() {
    console.log('rememberMe');
    localStorage.setItem("rememberMe", "true");
    localStorage.setItem("username", this.loginForm.value.username);
    localStorage.setItem("password", this.loginForm.value.password);
    this.toastrService.success('Remember me', 'You will be logged in automatically next time');
  }
}
